import React from 'react';

interface CustomIconProps {
  width?: string;
}

const FunnelIcon: React.FC<CustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '20'}
    height={width ?? '20'}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='bx-filter-alt'>
      <path
        id='Vector'
        d='M17.5026 2.5H4.16927C3.94826 2.5 3.7363 2.5878 3.58002 2.74408C3.42374 2.90036 3.33594 3.11232 3.33594 3.33333V5.49167C3.33594 5.9275 3.51344 6.35583 3.82177 6.66417L8.33594 11.1783V17.5C8.3361 17.642 8.3725 17.7816 8.44169 17.9055C8.51087 18.0295 8.61056 18.1338 8.73131 18.2085C8.85205 18.2832 8.98986 18.3258 9.13169 18.3323C9.27352 18.3389 9.41466 18.3091 9.54177 18.2458L12.8751 16.5792C13.1576 16.4375 13.3359 16.1492 13.3359 15.8333V11.1783L17.8501 6.66417C18.1584 6.35583 18.3359 5.9275 18.3359 5.49167V3.33333C18.3359 3.11232 18.2481 2.90036 18.0919 2.74408C17.9356 2.5878 17.7236 2.5 17.5026 2.5ZM11.9134 10.2442C11.8359 10.3214 11.7744 10.4132 11.7325 10.5144C11.6906 10.6155 11.6691 10.7239 11.6693 10.8333V15.3183L10.0026 16.1517V10.8333C10.0028 10.7239 9.98127 10.6155 9.93937 10.5144C9.89746 10.4132 9.83597 10.3214 9.75844 10.2442L5.0026 5.49167V4.16667H16.6701L16.6718 5.48583L11.9134 10.2442Z'
        fill='white'
      />
    </g>
  </svg>
);

export default FunnelIcon;
